import { useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/components/DashboardLayout";
import BrandDashboardLayout from "@/components/BrandDashboardLayout";
import Navbar from "@/components/Navbar";

/**
 * AppShell — layout intelligent basé sur le rôle.
 * - Talent connecté → DashboardLayout (sidebar talent)
 * - Professionnel connecté → BrandDashboardLayout (sidebar brand)
 * - Autres → Navbar publique
 */
export default function AppShell({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="w-10 h-10 border-2 border-[#1A1A1A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user?.role === "talent") {
    return <DashboardLayout>{children}</DashboardLayout>;
  }
  if ((user?.role === "creator" || user?.role === "professional")) {
    return <BrandDashboardLayout>{children}</BrandDashboardLayout>;
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      {children}
    </div>
  );
}
